import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import Icon from '../../../elementals/icon';
import PopupTooltip from '../../../overlays/popupTooltip';
import styles from '../styles.scss';
const cx = classnames.bind(styles);
const FieldTooltip = (props) => {
    const { on = 'hover', elmId, showError, helpContent, label, error, showAnchor = true, iconStyle = 'light', } = props;
    const iconInfo = !showError
        ? { name: 'info-circle', iconStyle, color: 'gray' }
        : { name: 'exclamation-circle', iconStyle, color: 'error' };
    return (_jsxs("div", { children: [!!showError && (_jsx("label", { "data-elm-id": `${elmId}_error_tooltip`, className: cx('tooltip-error'), children: error })), showAnchor && (_jsx(PopupTooltip, { "data-elm-id": `${elmId}_tooltip_content`, on: on, trigger: _jsx(Icon, { "data-elm-id": `${elmId}_tooltip`, fitted: true, ...iconInfo }), content: helpContent || label, position: 'top right', popperModifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['top', 'bottom'],
                        },
                    },
                ], offset: 0, horizontalOffset: 0, verticalOffset: 0 }))] }));
};
export default FieldTooltip;
//# sourceMappingURL=index.js.map